import { store } from "../redux/store";

const axios = require('axios').default;

const API_RESULT_OK = "success"; 
const API_RESULT_ERROR = "error"; 

const instance = axios.create({
    baseURL: process.env.REACT_APP_ENV === 'production' ? process.env.REACT_APP_API_URL : process.env.REACT_APP_DEVELOPMENT_API_URL,
    timeout: 10000,
    
});

const postRequest = async (url: string = "", params: any = {}) => {

    try {

        const { user } = store.getState(); 

        let formData = new FormData();

        for(let param in params) {

            if(params[param]) formData.append(param, params[param])

        }

        formData.append("token", user.token ? user.token : "");
        
        const result = await instance.post(url, formData); 

        if(result.data.status === API_RESULT_OK) {

            return result.data; 
            
        } else {

            throw new Error(result.data.message); 

        }

    } catch(error: any) {

        throw new Error(error); 

    }

}

export { postRequest }; 